import * as THREE from 'three';
import { useFrame, useThree } from "@react-three/fiber";
import { useCallback, useRef, useState } from "react";
import { Box, Flex } from '@react-three/flex';
import PageOne from '../Pages/PageOne';
import { useScreen } from '../../../context/ScreenCtx';
import PageTwo from '../Pages/PageTwo';
import PageThree from '../Pages/PageThree';
import PagePosition from '../../Position/PagePosition';
import OutlierBox from '../Boxes/OutlierBox';
import FaceSpaceBox from '../Boxes/FaceSpaceBox';
import ZoolanderBox from '../Boxes/ZoolanderBox';
import Links from '../../Html/Links';


function Content({ onReflow }) {
  const { top, setPages, setIsMobile } = useScreen();
  const [threshold, setThreshold] = useState(15);
  const group = useRef();
  const { viewport, size } = useThree();
  const vec = new THREE.Vector3();
  const lerpPage = useRef(top / size.height);

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime() / 3;
    const page = (lerpPage.current = THREE.MathUtils.lerp(lerpPage.current, top / size.height, 0.15));
    const yPos = page * viewport.height;
    const sticky = threshold * viewport.height;
    group.current.rotation.y * t
    group.current.position.lerp(vec.set(0, page < threshold ? yPos : sticky, page < threshold ? 0 : page * 1.25), 0.15);
  });

  const handleReflow = useCallback((w, h) => {
    onReflow(setPages(h / viewport.height + 5.5));
      if(viewport.width < 480) {
        setIsMobile(true)
      }
    }, [onReflow, viewport.height]);   


  const sizeRef = useRef([]);
  const scale = Math.min(1, viewport.width / 16);

  const handleThreshold = () => {
      setThreshold(Math.max(15, (15 / (15.8 * 3)) * sizeRef.current.reduce((acc, e) => acc + e, 0)));
  };

  return (
    <group ref={group}>
      <Flex 
        dir="column"
        // wrap='wrap'
        justify='flex-start'
        align='center'
        position={[-viewport.width / 2, viewport.height / 2, 0]} 
        size={[viewport.width, viewport.height, 0]} 
        onReflow={handleReflow}
      >
        <PagePosition onReflow={onReflow}/>
        <Box
            dir='row'
            width='100%'
            height='10vh'
            justify='space-around'
            align='space-around'
            marginTop={scale}
            marginBottom={scale * 1.25}
            marginRight={scale * 1.25}
          >
            <Links />
          </Box>
        <Box
          dir='column'
          justify='space-around'
          align='center'
        >
        <Box
          marginTop={3 * scale}
          marginBottom={scale}
          padding={0.2}
        >        
          <PageOne 
            scale={scale}
            align='center'
            onReflow={handleThreshold}
            viewport={viewport}
          />
          </Box>
          <Box marginBottom={2 * scale}>
          <PageThree 
            scale={scale}
            align='center'
            onReflow={handleThreshold}
            viewport={viewport}
          />
          </Box>
          <Box marginBottom={ 5 * scale}>
          <PageTwo 
            scale={scale}
            align='center'
            onReflow={handleThreshold}
            viewport={viewport}
          />
          </Box>
          <Box
            marginBottom={scale}
            marginLeft={scale}
          >
            <OutlierBox 
              scale={scale}
              align='center'
              onReflow={handleThreshold}
              viewport={viewport}
              txtOne='Outlier'
              txtTwo='null'
            />
          </Box>
          <Box 
            marginTop={scale}
            marginBottom={scale}
            marginRight={scale}
          >
            <FaceSpaceBox 
              scale={scale}
              align='center'
              onReflow={handleThreshold}
              viewport={viewport}
              txtOne='FaceSpace'
              txtTwo='null'
            />
          </Box>
          <Box marginTop={scale}>
            <ZoolanderBox 
              scale={scale}
              align='center'
              onReflow={handleThreshold}
              viewport={viewport}
              txtOne='zooLander'
              txtTwo='null'
            />
          </Box>
        </Box>
      </Flex>
    </group>
  )
}

export default Content;